import { PARTNERS } from '../../mock';
import { ShieldCheck, Award, Landmark } from 'lucide-react';

export default function TrustBar() {
  return (
    <section className="py-16 lg:py-20 border-b border-[#0B3B2E]/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-3 gap-6 lg:gap-4">
          <Badge
            icon={<Award className="w-5 h-5" />}
            title="Rated Excellent on Trustpilot"
            sub="Verified customer reviews"
          />
          <Badge
            icon={<Landmark className="w-5 h-5" />}
            title="£1B+ transferred each year"
            sub="For people and businesses worldwide"
          />
          <Badge
            icon={<ShieldCheck className="w-5 h-5" />}
            title="FCA authorised in the UK"
            sub="Client funds fully safeguarded"
          />
        </div>

        <p className="mt-14 text-center text-[11px] uppercase tracking-[0.25em] text-[#0E1F1A]/50">
          Trusted by leading firms across Europe
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {PARTNERS.map((p) => (
            <span
              key={p}
              className="font-serif text-[20px] lg:text-[22px] text-[#0E1F1A]/40 hover:text-[#0B3B2E] transition-colors duration-300 tracking-tight"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

function Badge({ icon, title, sub }) {
  return (
    <div className="reveal flex items-start gap-4 p-6 rounded-2xl bg-[#F5F1E8] border border-[#0B3B2E]/10 hover:border-[#0B3B2E]/25 hover:-translate-y-0.5 transition-all duration-300">
      <div className="w-10 h-10 rounded-full bg-[#0B3B2E] text-[#C8944B] flex items-center justify-center shrink-0">
        {icon}
      </div>
      <div>
        <h3 className="font-serif text-[19px] text-[#0B3B2E] leading-tight">{title}</h3>
        <p className="mt-1 text-[13px] text-[#0E1F1A]/60">{sub}</p>
      </div>
    </div>
  );
}
